/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { ConnectUsersDto } from '../../models/connect-users-dto';
import { EmptyResponse } from '../../models/empty-response';

export interface AgreementsControllerConnectUsers$Params {
  agreement_id: number;
      body: ConnectUsersDto
}

export function agreementsControllerConnectUsers(http: HttpClient, rootUrl: string, params: AgreementsControllerConnectUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: EmptyResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, agreementsControllerConnectUsers.PATH, 'put');
  if (params) {
    rb.path('agreement_id', params.agreement_id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: EmptyResponse;
      }>;
    })
  );
}

agreementsControllerConnectUsers.PATH = '/agreements/{agreement_id}/users';
